<router-outlet></router-outlet>
<ng-http-loader [filteredUrlPatterns]="['\\d', '[a-zA-Z]','getcompanyname','getindustryname']" spinner="sk-wave"></ng-http-loader>
